import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { map, take, switchMap, tap } from 'rxjs/operators';
import { Observable, of, from, timer } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';

import { AuthQuery } from './auth.query';

import { JournalService } from '@app/@core';
import { Logger } from '@core';
const log = new Logger('AuthenticationGuard');

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard  {
  constructor(
    private router: Router,
    private authQuery: AuthQuery,
    private cookieService: CookieService,
    private journalService: JournalService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authQuery.isLoggedIn) {
      // Check if user is kontakt (role_id 12) - only kontakt users can access monitoring app
      const userRole = this.authQuery.role;
      if (userRole !== 12) {
        log.debug('User is not kontakt (role_id 12), access denied. Role: ' + userRole);
        this.journalService.log('Zugriff verweigert: Nur Kontakt-Benutzer können auf die Monitoring-App zugreifen', '', '');
        this.router.navigate(['/login'], {
          queryParams: { error: 'access_denied', message: 'Nur Kontakt-Benutzer können auf die Monitoring-App zugreifen' },
          replaceUrl: true,
        });
        return false;
      }

      // set a cookie for the current day

      var wasHere = this.cookieService.get('logged-on-today');
      if (wasHere == '1') {
        // everything fine
        //console.log("was here");
      } else {
        this.cookieService.set('logged-on-today', '1', {
          expires: 60 * 60 * 12,
        });
        console.log('login mit remember me');
        this.journalService.log('Anmeldung mit Remember Me Funktion -------------', '', '');
      }

      // now check if the first start configuration wizzard has to be activated
      // check firststart
      //console.log("value: " + this.appQuery.getValue().appdata);

      //let xappData = this.adQuery.selectFirst().subscribe((data) => {
      //  console.log(data);
      //});
      /*
      return this.adQuery.selectFirst().pipe(
        map((data) => {
          //console.log(data);

          let appData = <IAppDataModel>data;

          return true;

          if (String(appData.activation.firststart_wizard).toLowerCase() == "true") {
            // setup wizzard is done
            console.log("it is done (true): " + appData.activation.modul1_paid);
            return true;
          } else {
            // setup wizzard is not done
            console.log("it is not done (false): " + appData.activation.modul1_paid);
            this.router.navigate(['/firststart'], { queryParams: { redirect: state.url }, replaceUrl: true });
            return true;
          }
        })
      );
      */

      //
      // check db and sync if necessary
      //
      //this._adQuery.selectEntity(this.authQuery.appid).subscribe((state) => {
      //console.log(state);
      //this.appData = <IAppDataModel>state;
      /*
        BUG Situation: canActivate does not wait until post is resolved
        ---> different solution needed
      console.log('check sync');
      this._adService.getAppDataVersion().subscribe((results) => {
        //console.log(results);
      });

      this._adService.getAppDataVersion().pipe(
        map((response) => {
          response.status === 'success';
          console.log(response);
        }),
        catchError((error) => of(false))
      );
      */

      /*
        var data = this._adService.getAppDataVersion(state).subscribe((data) => {
          console.log(data);
          debugger;
          console.log('current version: ' + this.authQuery.version + '/' + data.version);
          if (this.authQuery.version < data.version) {
            console.log('new version');
          }
        });
        */
      //this.cAppData = JSON.parse(JSON.stringify(this.appData));
      //});

      // Check if firststart_done is 0 - if so, redirect to change-password (mandatory for kontakt users)
      const firststartDone = this.authQuery.firststart_done;
      if (firststartDone === 0) {
        // User needs to change password - redirect to change-password page
        // Only redirect if not already on change-password page
        if (!state.url.includes('/auth/change-password')) {
          this.router.navigate(['/auth/change-password'], {
            queryParams: { redirect: state.url },
            replaceUrl: true,
          });
          return false;
        }
        // If already on change-password page, allow access
        return true;
      }

      // firststart is done, allow access
      return true;

      //return true;
    } else {
      // always redirect to login
      log.debug('Not authenticated, redirecting and adding redirect url...');
      this.router.navigate(['/login'], {
        queryParams: { redirect: state.url },
        replaceUrl: true,
      });
      return true;
    }
  }
}
